import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Header, Segment } from 'semantic-ui-react';

export function DisplayMessage({
  header, content, redirect, history,
}) {
  useEffect(() => {
    if (redirect && history) {
      const timeoutId = setTimeout(() => {
        history.replace('/');
      }, 3000);

      return () => clearTimeout(timeoutId);
    }

    return undefined;
  }, [history, redirect]);

  if (!content && redirect) {
    content = 'Wait 3 seconds to be redirected ...';
  }

  return (
    <div className='display-message flex items-center flex-column min-vh-100 w-100 pa3'>
      <div className='flex-auto flex justify-center flex-column'>
        <Segment raised color='blue' textAlign='center' padded>
          <Header size='large'>
            <Header.Content className='normal mb2'>
              {header}
            </Header.Content>
            <Header.Subheader>
              {content}
            </Header.Subheader>
          </Header>
        </Segment>
      </div>
    </div>
  );
}

DisplayMessage.propTypes = {
  redirect: PropTypes.bool,
  header: PropTypes.node.isRequired,
  content: PropTypes.node,
  history: PropTypes.object,
};
